import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { PopupMenu, type PopupMenuEntry } from '@kerfjs/ui/popup-menu';
import { type SafeHtml } from 'kerfjs';
import { Sparkles, Trash2 } from 'lucide';

import { decisionSubmenuEntry } from '../../../components/decision-submenu.js';
import { LineItemActions } from '../../../components/line-item-actions.js';
import { analysisReport, DECISION_ACTIONS, decisions, quoteMatrix, selectedLineIds } from '../../../data/state.js';
import { menuProps, type MenuTrigger } from '../../../lib/action-menu.js';
import { recommendedBatchDecisions } from '../../../lib/batch-decision.js';
import { currentDemandId } from '../../../lib/context.js';

export function SelectionActionsMenu({ count, trigger }: { count: number; trigger: MenuTrigger }): SafeHtml {
  if (count === 1) {
    const lineId = selectedLineIds.value[0];
    if (lineId === undefined) return <></>;
    return (
      <LineItemActions
        demandId={currentDemandId()}
        lineId={lineId}
        currentAction={decisions.value.find((decision) => decision.lineItemId === lineId)?.action}
        trigger={trigger}
      />
    );
  }
  const disabledActions = new Set<string>();
  const ids = selectedLineIds.value;
  if (recommendedBatchDecisions('approve', ids, quoteMatrix.value, analysisReport.value) === undefined)
    disabledActions.add('approve');
  if (recommendedBatchDecisions('negotiate', ids, quoteMatrix.value, analysisReport.value) === undefined)
    disabledActions.add('negotiate');
  const entries: PopupMenuEntry[] = [
    {
      label: 'Accept AI Recommendations',
      action: 'decisions-bulk',
      icon: <LucideIcon icon={Sparkles} name="" />,
    },
    decisionSubmenuEntry({ actions: DECISION_ACTIONS, actionName: 'batch-decide', disabledActions }),
    { kind: 'divider' },
    {
      label: `Remove ${String(count)} Selected`,
      action: 'lines-batch-remove',
      tone: 'danger',
      icon: <LucideIcon icon={Trash2} name="" />,
    },
  ];
  return <PopupMenu {...menuProps(trigger, entries)} />;
}
